import { StaticInterface } from '../../../helpers/static-interface';

export interface ITpxIconCardUtils {
  addClickHandler: (parentEl: HTMLElement) => void;
}

export interface IStaticIconCardUtils {
  new (...args: any[]): ITpxIconCardUtils;
  init(): void;
}

/**
 * IconCard utilities
 * @class
 */
export default class TpxIconCardUtils
  implements StaticInterface<IStaticIconCardUtils, typeof TpxIconCardUtils>
{
  constructor(element: HTMLElement) {
    this.addClickHandler(element);
  }

  /**
   * Make the whole card clickable if there's a CTA
   */
  addClickHandler(parentEl: HTMLElement): void {
    const link = parentEl.querySelector(
      '[data-component="icon-card__link"]'
    ) as HTMLAnchorElement;
    if (link && link.href) {
      parentEl.onclick = () => (location.href = link.href);
    }
  }

  static init(scope?: HTMLElement) {
    [
      ...(scope || document).querySelectorAll('[data-component="icon-card"]'),
    ].forEach((card) => {
      new TpxIconCardUtils(card as HTMLElement);
    });
  }
}
